module.exports = __webpack_public_path__ + "img/1492723305.fc2b8043.jpg";